import { Component, type ErrorInfo, type ReactNode } from 'react';
import withLogo from '@/assets/with_logo.png';
import { reportError } from '@/utils/reportError';

import cs from './ErrorBoundary.module.scss';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportError(error, {
      type: 'react-error-boundary',
      componentStack: errorInfo.componentStack,
      errorBoundary: this.constructor.name,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className={cs.errorContainer}>
            <div className={cs.dialog}>
              <a href="/" className={cs.logoLink}>
                <img className={cs.logo} src={withLogo} alt="with" />
              </a>
              <div>
                <h1 className={cs.title}>エラーが発生しました</h1>
                <p className={cs.message}>
                  申し訳ございません。予期しないエラーが発生しました。しばらく時間をおいてからもう一度お試しください。
                </p>
                <a href="/" className={cs.topLink}>
                  トップへ戻る
                </a>
              </div>
              <p className={cs.copyright}>©with</p>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
